import { render, staticRenderFns } from "./todayData.vue?vue&type=template&id=efcf6fba&scoped=true&"
import script from "./todayData.vue?vue&type=script&lang=js&"
export * from "./todayData.vue?vue&type=script&lang=js&"
import style0 from "./todayData.vue?vue&type=style&index=0&id=efcf6fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcf6fba",
  null
  
)

export default component.exports